// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"477": "flags","787": "BadgeTooltipV1","83": "CreateCollectionModal","882": "NotableClientsAbout","883": "SaveToListPopover",}[chunkId] + "." + {"477": "afbcd1bebb14fb94","787": "de58a6e3b068335a","83": "d8bd9585e6ed6427","882": "dbfeb393db2bc6cd","883": "259ec6e96a1f393a",}[chunkId] + ".js"
}